/**
 * Which size of the product the stickers describe and which barcodes they
 * carry.
 */
import type { Order } from '@/features/orders/api';

export interface ProductSize {
  size?: string | number | null | undefined;
  ean13CentralFlow?: string | null | undefined;
  m3SkuCentralFlow?: string | null | undefined;
  [key: string]: unknown;
}

/** The size ordered: the only one of the product, or the one matching `product.size`. */
export const orderedSize = (order: Order): ProductSize | undefined => {
  const product = (order.product ?? {}) as {
    sizes?: unknown;
    size?: unknown;
  };
  const sizes = product.sizes;
  if (!Array.isArray(sizes)) return undefined;
  const list = sizes as ProductSize[];
  if (list.length === 1) return list[0];
  return list.find((item) => String(item.size) === String(product.size));
};

/** The EAN printed on the box: the central flow one of the size, else the product's. */
export const boxEan = (
  order: Order,
  size: ProductSize | undefined,
): string | undefined => {
  const product = (order.product ?? {}) as { eanCode?: unknown };
  const ean = size?.ean13CentralFlow || product.eanCode;
  return typeof ean === 'string' && ean ? ean : undefined;
};

export const BARCODE_OPTIONS = {
  fontOptions: 'bold',
  fontSize: 100,
  background: '#ffffff',
  width: 8,
  height: 300,
  margin: 4,
} as const;
